import {Options, Question, StepperOptions} from '../../shared/components/dynamic-form/dynamic-form'
import {QuestionType} from '../../../__generated__/types'
import {DynamicQuestionSummary} from '../../shared/components/dynamic-form/dynamic-form-summary/dynamic-form-summary.component'

export class DynamicOfferingDetailsService {
  static toClientFacingQuestions(questions: ClientFacingQuestion[]): Question[] {
    return questions?.map(q => this.toClientFacingQuestion(q))
  }

  static toClientFacingQuestion(q: ClientFacingQuestion): Question {
    return {
      id: q.id,
      label: q.clientFacingLabel,
      order: q.rank,
      error: q.errorLabel,
      required: q.required,
      type: q.type,
      options: this.toOptions(q),
    }
  }

  static toDynamicQuestionSummary(questions: ProFacingQuestion[]): DynamicQuestionSummary[] {
    return (
      questions?.map(q => ({
        additionalInformation: q.additionalInformation,
        label: q.proFacingLabel,
        rank: q.rank,
        type: q.type,
        answers: q.answers?.length ? q.answers?.map(a => a.label!) : [q.answerValue!],
      })) ?? []
    )
  }

  static toOptions(q: ClientFacingQuestion): Options {
    const config = q.stepperConfiguration

    if (config && typeof config === 'object' && Number.isInteger(config.lowerBound)) {
      return {
        min: config.lowerBound,
        max: config.upperBound,
        step: config.stepSize,
      } as StepperOptions
    }

    return q.possibleAnswers
      ? q.possibleAnswers
          .slice()
          .sort((a, b) => a.rank - b.rank)
          .map(a => ({key: a.id, value: a.label!, requireAdditionalInformation: a.requireAdditionalInformation}))
      : []
  }
}

interface Answer {
  id: string
  label?: string
  rank: number
  requireAdditionalInformation: boolean
}

interface ClientFacingQuestion {
  id: string
  clientFacingLabel: string
  rank: number
  errorLabel?: string
  required: boolean
  type: QuestionType
  stepperConfiguration?: {
    lowerBound: number
    upperBound: number
    stepSize: number
  }
  possibleAnswers?: Answer[]
}

interface ProFacingQuestion {
  additionalInformation?: string
  proFacingLabel: string
  rank: number
  type: QuestionType
  answerValue?: string
  answers?: {label?: string}[]
}
